import React, { useState, useEffect } from "react";
import { Card, Form, Row } from "react-bootstrap";
import { CForm, CCol, CFormLabel, CFormFeedback, CFormInput, CButton } from "@coreui/react";
import { useDispatch } from "react-redux";

import { checkEmpty, toastMessage } from "../../../helpers/utility.js";
import { getMasterData, addCustomer, editCustomer } from "../../../redux/slices/CustomerSlice.js";

const JOB_TYPE_PARAMS = {
    skip: 0,
    take: 2000,
    type: 'job_type',
    sorting: 'asc',
    sorting_key: 'created_at',
    filter: { }
};

const INIT_FORM_DATA = {
    client_Id: 1,
    // customer_Code: "",
    customer_Name: "",
    customer_address_Line_1: "",
    customer_address_Line_2: "",
    customer_Mobile_Country_Code: "+91",
    customer_Mobile: "",
    customer_Registration_No: "",
    jobRate: [],
    ledger_Opening_Balance: '',
    ledger_type: ''
};

const INIT_APPLICABLE_RATE_FORM_DATA = {
    job_type_code: "",
    rate: 0,
};

const CustomerAddEdit = ({reloadList, onSave, mode, data, section}) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState(INIT_FORM_DATA);
    const [validated, setValidated] = useState(false);
    // const [isEdit, setIsEdit] = useState(false);
    const [masterJobTypeData, setMasterJobTypeData] = useState([]);
    const [applicableRateFormData, setApplicableRateFormData] = useState(INIT_APPLICABLE_RATE_FORM_DATA);
    const [applicableRate, setApplicableRate] = useState([]);
    const [isSaveDisabled, setIsSaveDisabled] = useState(false);

    useEffect(()=> {
        fetchMasterData();
    }, []);

    useEffect(() => {
        if (mode && data) {
            setFormData({
                customer_Id: data.customer_Id || "",
                // customer_Code: data.customer_Code || "",
                customer_Name: data.customer_Name || "",
                customer_address_Line_1: data.customer_address_Line_1 || "",
                customer_address_Line_2: data.customer_address_Line_2 || "",
                customer_Mobile_Country_Code: data.customer_Mobile_Country_Code || "+91",
                customer_Mobile: data.customer_Mobile || "",
                customer_Registration_No: data.customer_Registration_No || "",
                ledger_Opening_Balance: data.ledger_Opening_Balance || "",
                ledger_type: data.ledger_type || "",
                jobRate: data.jobRate || [],
            });
    
            setApplicableRate(data.jobRate || []); // Populate `applicableRate` if provided
        }
    }, [mode, data]);

    const fetchMasterData = async() => {
        try{
            const { payload } = await dispatch(getMasterData({ inputData: JOB_TYPE_PARAMS }));
            setMasterJobTypeData(payload?.job_type);
        } catch (err) {
            toastMessage("error", "Failed to fetch data");
        } finally {
        }
    };

    const handleInputChange = (e) => {
        const {name, value} = e.target;

        // Check for special characters in customer_Name
        // if (name === "customer_Name") { // || name === "customer_Registration_No"
        //     const isValid = value === "" || /^[a-zA-Z\s]+$/.test(value); // Allows only letters and spaces
        //     if (!isValid) {
        //         toastMessage("error", "Special characters are not allowed in the input.");
        //         return;
        //     }
        // }

        if (name === "customer_Mobile" || name === "ledger_Opening_Balance") {
            if (/^\d*$/.test(value)) { // Allows only digits
                setFormData((prevData) => ({ ...prevData, [name]: value }));
            }
            return; // Prevent further execution
        }

        setFormData({...formData, [name] : value});
    };

    const handleApplicableRateInputChange = (e) => {
        let {name, value} = e.target;

        if (name === "rate" && value.length > 1 && value.startsWith("0")) {
            value = value.replace(/^0+/, "");
        }

        if (name === "rate"){
            if(/^\d*\.?\d{0,2}$/.test(value)){
                setApplicableRateFormData({...applicableRateFormData, [name] : value});
            }
        } else {
            setApplicableRateFormData({...applicableRateFormData, [name] : value});
        }
    };

    const formatText = (text) => {
        return text
          .replace(/_/g, " ") // Replace underscores with spaces
          .split(" ") // Split into words
          .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter
          .join(" "); // Join back into a string
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        } else {
            handleSave();
        }
        setValidated(true);
    };

    const handleSave = async () => {
        if (applicableRate.length === 0) {
            toastMessage("error", "Please add at least one job rate before submitting!");
            return;
        }
        setIsSaveDisabled(true);
        
        const updatedPaylod = {
            ...formData, jobRate: applicableRate
        };

        let api = mode ? editCustomer : addCustomer;
        
        const { payload } = await dispatch(api({ inputData: updatedPaylod }));
        if (payload?.status === "error") {
            setIsSaveDisabled(false);
            toastMessage("error", payload.msg || "An error occurred while saving.");
        } else {
            setIsSaveDisabled(false);
            toastMessage(payload?.status || "success", payload?.msg || "Operation successful.");
            if(section === "Customer"){
                reloadList();
            }
            onSave();
        }
    };

    const addApplicableRate = () => {
        if(checkEmpty(applicableRateFormData.job_type_code)){
            toastMessage("error", "Select Job Type");
        }
        // else if(checkEmpty(applicableRateFormData.rate)){
        //     toastMessage("error", "Enter rate");
        // }
        else {
            setApplicableRate((prevArray) => [...prevArray, applicableRateFormData]);
            setApplicableRateFormData(INIT_APPLICABLE_RATE_FORM_DATA);
        }
        // if(!checkEmpty(applicableRateFormData.job_type_code) && !checkEmpty(applicableRateFormData.rate)){
        //     console.log("addApplicableRate called..", applicableRateFormData);
        //     setApplicableRate((prevArray) => [...prevArray, applicableRateFormData]);
        //     setApplicableRateFormData(INIT_APPLICABLE_RATE_FORM_DATA);
        // }
        // toastMessage("error", "Blank Job Type & Rate Not Allowed!");
    };

    const removeApplicableRate = (indexToRemove) => {
        setApplicableRate((prevArray) => prevArray.filter((_, index) => index !== indexToRemove));
    };

    return(
        <CForm
            className="g-3 needs-validation"
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            >
            {/* Customer Details */}
            <Card>
                <Card.Header className="pb-0">
                    <h3 className="card-title">Customer Details</h3>
                </Card.Header>
                <Card.Body className="py-0">
                    
                        <Row className="row-xs mb-2">
                            {/* <CCol md={2}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="customer_Code">Cust. Code</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="customer_Code"
                                    name="customer_Code"
                                    value={formData.customer_Code}
                                    onChange={handleInputChange}
                                    required
                                />
                                <CFormFeedback invalid>Code</CFormFeedback>
                            </CCol> */}
                            <CCol md={12}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="customer_Name">Customer Name</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="customer_Name"
                                    name="customer_Name"
                                    value={formData.customer_Name}
                                    onChange={handleInputChange}
                                    required
                                    // pattern="^[a-zA-Z\s]+$" // Ensures no special characters
                                />
                                <CFormFeedback invalid>Enter customet name</CFormFeedback>
                            </CCol>
                        </Row>
                        <Row className="row-xs mb-2">
                            <CCol md={6}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="customer_Mobile">Mobile</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="customer_Mobile"
                                    name="customer_Mobile"
                                    value={formData.customer_Mobile}
                                    onChange={handleInputChange}
                                    // required
                                    // pattern="[0-9]{10}"
                                />
                                <CFormFeedback invalid>Mobile number is required</CFormFeedback>
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="customer_Registration_No">Registration No</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="customer_Registration_No"
                                    name="customer_Registration_No"
                                    value={formData.customer_Registration_No}
                                    onChange={handleInputChange}
                                    // required
                                    // pattern="^[a-zA-Z\s]+$" // Ensures no special characters
                                />
                                {/* <CFormFeedback invalid>Enter registration no</CFormFeedback> */}
                            </CCol>
                        </Row>
                        <Row className="row-xs mb-2">
                            <CCol md={6}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="customer_address_Line_1">House No</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="customer_address_Line_1"
                                    name="customer_address_Line_1"
                                    value={formData.customer_address_Line_1}
                                    onChange={handleInputChange}
                                />
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="customer_address_Line_2">Street Name</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="customer_address_Line_2"
                                    name="customer_address_Line_2"
                                    value={formData.customer_address_Line_2}
                                    onChange={handleInputChange}
                                />
                            </CCol>
                        </Row>
                        <Row className="row-xs mb-2">
                            <CCol md={9}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="ledger_Opening_Balance">Opening Balance</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="ledger_Opening_Balance"
                                    name="ledger_Opening_Balance"
                                    value={formData.ledger_Opening_Balance}
                                    onChange={handleInputChange}
                                />
                            </CCol>
                            <CCol md={3}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="ledger_type">Type</CFormLabel>
                                <Form.Select
                                    className="form-control"
                                    id="ledger_type"
                                    name="ledger_type"
                                    value={formData.ledger_type}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Select</option>
                                    <option value="Dr">Dr</option>
                                    <option value="Cr">Cr</option>
                                </Form.Select>
                            </CCol>
                        </Row>
                </Card.Body>
            </Card>

            {/* Applicable Rates */}
            <Card>
                <Card.Header className="pb-0">
                    <h3 className="card-title">Applicable Rates</h3>
                </Card.Header>
                <Card.Body className="py-0">
                    <Row className="row-xs mb-2">
                        <CCol md={7}>
                            <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="job_type_code">Job Type</CFormLabel>
                            <Form.Select
                            className="form-control"
                            id="job_type_code"
                            name="job_type_code"
                            value={applicableRateFormData.job_type_code}
                            onChange={handleApplicableRateInputChange}
                            >
                                <option value="">Select</option>
                                {masterJobTypeData?.map((option, index) => (
                                    <option key={index} value={option.job_type_Code}>
                                    {option.job_type_Name}
                                    </option>
                                ))}
                            </Form.Select>
                        </CCol>
                        <CCol md={4}>
                            <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="rate">Rate</CFormLabel>
                            <CFormInput
                                type="text"
                                id="rate"
                                name="rate"
                                value={applicableRateFormData.rate}
                                onChange={handleApplicableRateInputChange}
                            />
                        </CCol>
                        <CCol md={1}>
                            <CButton color="primary" className="btn btn-sm" style={{marginTop: "30px"}} onClick={()=>{addApplicableRate()}}>+</CButton>
                        </CCol>
                    </Row>
                    {applicableRate?.map((item, index) => (
                        <Row className="row-xs mb-2" key={index}>
                            <CCol md={7}>
                                {/* {item.job_type_code} */}
                                <CFormInput
                                    type="text"
                                    value={formatText(item.job_type_code)}
                                    disabled={true}
                                />
                            </CCol>
                            <CCol md={4}>
                                {/* {item.rate} */}
                                <CFormInput
                                    type="text"
                                    value={item.rate}
                                    disabled={true}
                                />
                            </CCol>
                            <CCol md={1}>
                                <CButton color="danger" className="btn btn-sm mt-1" onClick={()=>{removeApplicableRate(index)}}>-</CButton>
                            </CCol>
                        </Row>
                    ))}
                </Card.Body>
            </Card>

            {/* Action Button */}
            <Row className="row-xs mb-2 btn-animation">
                <CCol xs={12} className="mt-10">
                    <CButton
                     color="primary"
                     className={`btn btn-sm float-end ${isSaveDisabled ? 'btn-loaders' : ''}`}
                     type="submit"
                     disabled={isSaveDisabled}
                     >
                        {isSaveDisabled ? (<span className="loading">Save Changes</span>) : "Save Changes"}
                    </CButton>
                    <CButton color="secondary" className="btn btn-sm float-end me-2" onClick={onSave} disabled={isSaveDisabled}>Close</CButton>
                </CCol>
            </Row>
        </CForm>
    );
};

export default CustomerAddEdit;